import React, { useState, useEffect } from 'react';
import { createCommunityInvites } from '../../ajax_utils';
import { flashForReact } from '../../flash_react';
import { takeEmailColumn, validateInputEmails } from './member_utils';
import CSVReader from '../csv_reader';
import Table from '../table';

const Invite = ({ community, setTab, setToggleInviteTab }) => {
  const [inviteType, setInviteType] = useState('emails');
  const [message, setMessage] = useState('');
  const [link, setLink] = useState(`https://voray.com/${community.slug}`);
  const [CSVData, setCSVData] = useState([]);
  const [params, setParams] = useState(null);
  const [emailsFromInput, setEmailsFromInput] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let emailsList = [];

    if (CSVData.length) {
      emailsList = takeEmailColumn(flashForReact, CSVData);
      emailsList.length === 0 && setCSVData([]);
    }

    if (emailsFromInput.length) {
      emailsList = emailsFromInput.split(',').map((email) => email.trim());
    }

    setParams({ invite_type: inviteType, emails: emailsList, format: 'json', link, message });

  }, [inviteType, CSVData, link, message, emailsFromInput]);

  const handleChange = (e, callback) => {
    e.preventDefault();
    callback(e.target.value);
  };

  const handleEmailInput = (e) => {
    e.preventDefault();
    setEmailsFromInput(e.target.value);
    setCSVData([]);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  const handleApiSuccess = (res) => {
      setLoading(false);
      flashForReact('notice', res.message);
      setToggleInviteTab(false);
      setTab('invited');
  };

  const handleApiErrors = (err) => {
    setLoading(false);
	  let errMsg = '';
	  if (Object.hasOwn(err, 'responseJSON')) {
		  errMsg = err.responseJSON.message;
	  } else if (Object.hasOwn(err, 'responseText')) {
		  const maxErrSize = 100; // TODO should be a configurable variable at some other file
		  errMsg = 'Internal server error: ' + err.responseText.substring(0, maxErrSize);
	  } else {
		  errMsg = 'Unhandled error';
	  }
      flashForReact('danger', errMsg);
  };

  const handleInviteSend = () => {
    if (!CSVData.length && !emailsFromInput.length) {
      flashForReact('danger', 'Please enter emails or add CSV to send invites');
    }
    if (!validateInputEmails(params.emails, flashForReact)) return;

    createCommunityInvites(params, handleApiSuccess, handleApiErrors);
    setLoading(true);
  };

  const handleReset = () => {
    setEmailsFromInput('');
    setCSVData([]);
  };

  const showClearBtn = () => (
    emailsFromInput.length || CSVData.length ? '' : 'd-none'
  );

  return (
    <div id="invite-page">
      <header className="border-bottom pb-md-5">
        <div className="mb-2">
          <p className="h2 col-lg-6 mt-n2">Invite Members</p>
          <p className="fs-85 mb-0">Share a link</p>
        </div>
        <div className="community-link mb-4 col-md-8">
          <input
            className="form-control border fs-6 p-3 rounded-3 w-100"
            defaultValue={link}
            type="link"
            placeholder="Community link"
            aria-label="Community link"
            onChange={(e) => handleChange(e, setLink)}
          />
        </div>
      </header>
      <div>
        <p className="fs-85 mt-6">Send invites</p>
        <div className="justify-content-between mb-6 col-md-8 d-md-flex">
          <div className="col-md-3 ps-md-0 mb-2 mb-md-0 d-md-flex">
            <div className="col-12">
              <input
                type="radio"
                className="btn-check"
                name="options"
                id="btn-check-1-outlined"
                defaultChecked={inviteType === 'emails'}
                autoComplete="off"
              />
              <label
                className="btn btn-outline-primary member-btn col-12 col-md-3 mb-2 mb-md-0"
                htmlFor="btn-check-1-outlined"
                onClick={() => setInviteType('emails')}
              >
                Emails
              </label>
            </div>
            <div className="col-12 ms-md-4">
              <input
                type="radio"
                className="btn-check"
                name="options"
                id="btn-check-2-outlined"
                autoComplete="off"
                defaultChecked={inviteType === 'csv'}
              />
              <label
                className="btn btn-outline-primary member-btn col-12 col-md-4"
                htmlFor="btn-check-2-outlined"
                onClick={() => setInviteType('csv')}
              >
                CSV
              </label>
            </div>
          </div>
          <button className={`${showClearBtn()} col-md-3 col-12 text-nowrap btn btn-outline-primary`} onClick={handleReset}>Clear emails</button>
        </div>
        { inviteType === 'emails' ? (
          <div className="form-group col-md-8">
            <textarea value={emailsFromInput} className="form-control" cols="30" rows="6" placeholder="Please enter emails separated by a comma" onChange={(e) => handleEmailInput(e)} onKeyDown={(e) => handleKeyDown(e)} />
          </div>
        ) : (
          CSVData.length > 0
          ? <Table headers={'Emails'} data={takeEmailColumn(flashForReact, CSVData)} />
          : <CSVReader setCSVData={setCSVData} resetInputEmails={() => setEmailsFromInput([])} />
        )

        }

        <p className="fs-85 ps-md-0">Add a message</p>
        <div className="mb-6 col-md-8">
          <form className="ps-md-0">
            <textarea
              className="form-control border rounded-2 col-12 col-md-8 invite-box"
              placeholder="Let those you invite know why you are inviting them to this community"
              onChange={(e) => handleChange(e, setMessage)}
            />
          </form>
        </div>
        <button
          className="btn btn-primary btn-lg col-md-3 col-12 py-3 mb-10"
          onClick={handleInviteSend}
          disabled={loading}
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
              Sending...
            </>
          ) : (
            'Send Invites'
          )}
        </button>
      </div>
    </div>
  );
};

export default Invite;
